import { render, staticRenderFns } from "./action-link-extended-preferences-manage-modal.vue?vue&type=template&id=10fc07a7"
import script from "./action-link-extended-preferences-manage-modal.vue?vue&type=script&lang=js"
export * from "./action-link-extended-preferences-manage-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports